enum Environment {
  development = 'development',
  staging = 'staging',
  production = 'production',
}

export default Environment
